import Container from "@/components/common/Container";
import Image from "next/image";
import { useState } from "react";
import Modal from "../common/Modal";
import Title from "../common/Title";

const OurServices = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  return (
    <>
      <Container large className="pb-36 md:pb-40">
        <Title
          description="When you decide to work with ultroNeous, we do honor the
    responsibility of taking care of your project. Our unwavering
    commitment and drive for innovation balances the performance with
    creativity."
          descriptionClass="text-base text-primary-black text-center md:px-64 pb-10 md:pb-24 font-light md:font-medium"
          subTitle="Our Services"
          subTitleClass="text-4xl md:text-6xl text-primary-black text-center mb-6 lg:pb-2 pt-20 md:pt-40 font-medium"
        />
        <div className="flex flex-col md:flex-row pb-14 md:pb-36">
          <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
            <div className="fs-0 rounded-2xl">
              <Image
                alt="Real Time Crawling Services"
                height={416}
                src="/assets/data-solution/realtimecrawlingservices.webp"
                width={648}
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:pl-12">
            <h3 className="text-xl md:text-4xl text-black font-normal mb-4 lg:pt-4">
              <span>Real Time Crawling Services</span>
            </h3>
            <p className="text-sm md:text-base text-black font-normal text-justify lg:pb-12 lg:mb-4">
              <span>
                Experience seamless data retrieval with ultroNeous&#39;
                Real-Time Crawling Services. Gain instant access to dynamic,
                up-to-the-minute data streams, empowering your decision- making
                process with timely insights for unparalleled business agility
                and competitive advantage. Elevate your operations with our
                cutting-edge solutions tailored to your specific needs.
              </span>
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row-reverse pb-14 md:pb-36">
          <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
            <div className="fs-0 rounded-2xl text-right">
              <Image
                alt="Retailer Intelligence"
                height={416}
                src="/assets/data-solution/retailerintelligence.webp"
                width={648}
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:pr-12">
            <h3 className="text-xl md:text-4xl text-black font-normal mb-4 lg:pt-4">
              <span>Retailer Intelligence</span>
            </h3>
            <p className="text-sm md:text-base text-black font-normal text-justify lg:pb-12 lg:mb-4">
              <span>
                Dive into the realm of retail with ultroNeous&#39; Retailer
                Intelligence. Gain actionable insights into market trends,
                competitor strategies, and consumer behavior, enabling informed
                decision-making for optimized operations and sustained growth.
                Discover the power of data-driven retail excellence tailored to
                your business objectives.
              </span>
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row pb-14 md:pb-36">
          <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
            <div className="fs-0 rounded-2xl text-left">
              <Image
                alt="Travel Intelligence"
                height={416}
                src="/assets/data-solution/travelintelligence.webp"
                width={648}
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:pl-12">
            <h3 className="text-xl md:text-4xl text-black font-normal mb-4 lg:pt-4">
              <span>Travel Intelligence</span>
            </h3>
            <p className="text-sm md:text-base text-black font-normal text-justify lg:pb-12 lg:mb-4">
              <span>
                Embark on a journey of data-driven discovery with
                ultroNeous&#39; Travel Intelligence. Uncover insights into
                market trends, destination preferences, and traveler behavior
                for enhanced decision-making and tailored strategies. Experience
                the transformative power of actionable intelligence, guiding
                your travel business towards success and customer satisfaction.
              </span>
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row-reverse pb-14 md:pb-36">
          <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
            <div className="fs-0 rounded-2xl text-right">
              <Image
                alt="Real Estate Web Scraping API"
                height={416}
                src="/assets/data-solution/realestatedatascraping.webp"
                width={648}
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:pr-12">
            <h3 className="text-xl md:text-4xl text-black font-normal mb-4 lg:pt-4">
              <span>Real Estate Web Scraping API</span>
            </h3>
            <p className="text-sm md:text-base text-black font-normal text-justify lg:pb-12 lg:mb-4">
              <span>
                Navigate the ever-changing real estate landscape with
                ultroNeous&#39; Real Estate Intelligence. From market insights
                to investment strategies, we provide the roadmap for your
                property journey. Let&#39;s turn data into your competitive
                edge, shaping your real estate success story uniquely.
              </span>
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row">
          <div className="w-full lg:w-1/2 pb-6 md:pb-0 mb-2 md:mb-0">
            <div className="fs-0 rounded-2xl text-left">
              <Image
                alt="Grocery Price Insights"
                height={416}
                src="/assets/data-solution/grocerypriceinsights.webp"
                width={648}
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:pl-12">
            <h3 className="text-xl md:text-4xl text-black font-normal mb-4 lg:pt-4">
              <span>Grocery Price Insights</span>
            </h3>
            <p className="text-sm md:text-base text-black font-normal text-justify lg:pb-12 lg:mb-4">
              <span>
                Unlock the secrets behind grocery pricing with Grocery Price
                Insights. Our cutting-edge data scraping technology dives deep
                into online stores, extracting vast amounts of real-time data on
                prices, promotions, and inventory levels. We analyze this data
                with powerful algorithms, uncovering hidden trends, predicting
                price fluctuations, and revealing the best deals across brands
                and retailers. Gain unmatched insights to optimize your business
                strategies, stay ahead of the curve, and empower informed
                decision-making.
              </span>
            </p>
          </div>
        </div>
        <div className="flex justify-center pt-20">
          <button
            onClick={openModal}
            className="border border-solid border-primary-yellow rounded-lg text-base md:text-sm xl:text-lg font-medium outline-none transition-all duration-500 ease-out hover:ease-in px-10 py-4 mx-auto inline-block min-w-56 md:min-w-48 xl:min-w-64 text-center bg-primary-yellow text-white hover:bg-transparent hover:text-primary-yellow"
          >
            Get Free Consultation
          </button>
        </div>
      </Container>
      <Modal isOpen={modalOpen} onClose={closeModal} />
    </>
  );
};

export default OurServices;
